import _ from "lodash";
import { BuildingAttribute } from "./building-attribute.service";
import { CameraService } from "./camera.service";
import { CoreService } from "./core.service";
import { EntityMapEntity } from "./facility-pin.service";
import { WindowService } from "./window.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataContextService } from "./data-context.service";
import { TimelineService } from "./timeline.service";
import { OrganizationUtilService } from "./organization-util.service";

export class BuildingMapEntity extends EntityMapEntity {
  perimeterId: string;
  areaIds: string[];
  incidents: any[] = [];
  buildingid: string;
  relationid: string;
  buildingBuilt = false;
  fixCamera: boolean;
  pin: any;
  declare cesiumEntity: any;
  floorPerimeters: any[] = [];
  relatedEntities: any[] = [];
  associatedOrgs: { [key: string]: boolean } = {};
  surroundings: any;
  centerfloor: any;
  initViewPosLat: number | undefined;
  initViewPosLon: number | undefined;
  initViewRange: number | undefined;
  initViewHeading: number | undefined;
  initViewPitch: number | undefined;
  initViewHeight: number | undefined;
  isExteriorVisible: any;
  type: any;
  associatedBuilding: any;
  associatedcampus?: any[] = [];
  assignedOrgId?:any;
  public alertCount = 0;
  dangerUserCount: number = 0;
  safeUserCount: number = 0;
  unknownUserCount: number = 0;
  suspectUserCount: number = 0;
  buildingUsers: any;

  constructor(
    mapEntityName: string,
    buildingid: string,
    relationid: string,
    areaIds: string[],
    fixCamera: boolean,
    perimeterId: string,
    camera: CameraService,
    coreService: CoreService,
    windowService: WindowService,
    dataContext: DataContextService,
    modalService: NgbModal,
    timelineService: TimelineService,
    private orgutil: OrganizationUtilService
  ) {
    super(mapEntityName, 'ArcAngel//Buildings',camera,coreService, windowService, dataContext, modalService,timelineService);
    this.perimeterId = perimeterId;
    this.areaIds = areaIds;
    this.buildingid = buildingid;
    this.relationid = relationid;
    this.fixCamera = fixCamera;
    this.addAttribute(new BuildingAttribute(this.id));

    // this.removeDeleteCommand();
    // this.removeShowHideCommand();
    // this.removeTimelineCommand();
    this.setShowInLayersUI(false);
  }

  getAreaIds(): string[] {
    return this.areaIds;
  }

  setAreaEntities(areaEntities: any[]): void {
    this.floorPerimeters = areaEntities;
    for (const floor of this.floorPerimeters) {
      floor.setParentBuilding(this);
    }
    this.floorPerimeters.sort((lhs, rhs) => lhs.floorNumber - rhs.floorNumber);
  }

  setAlertCount(count: number): void {
    this.alertCount = count;
  }

  getAlertCount(): number {
    return this.alertCount;
  }

  restoreTransparency(): void {
    this.floorPerimeters.forEach(floorEntity => floorEntity.restoreTransparency());
  }

  increaseTransparency(): void {
    this.floorPerimeters.forEach(floorEntity => floorEntity.increaseTransparency());
  }

  getBuildingId(): string {
    return this.buildingid;
  }

  getRelationId(): string {
    return this.relationid;
  }

  getLatitude(): number {
    return this.getCenterLatitude() ?? 0;
  }

  getLongitude(): number {
    return this.getCenterLongitude() ?? 0;
  }

  setLatitude(latitude: number): void {
    this.setCenterLatitude(latitude);
  }

  setLongitude(longitude: number): void {
    this.setCenterLongitude(longitude);
  }

  setAssociatedPin(pin: any): void {
    this.pin = pin;
  }

  getAssociatedPin(): any {
    return this.pin;
  }

  setBuildingEntity(buildingEntity: any): void {
    this.cesiumEntity = buildingEntity;
    this.buildingBuilt = true;
    // Optionally add Cesium billboard logic here
  }

  buildBuilding(): void {}

  override buildEntity(): void {
    super.buildEntity();
  }

  showFloors(): void {
    this.floorPerimeters.forEach(floor => floor.show());
  }

  hideFloors(): void {
    this.floorPerimeters.forEach(floor => floor.hide());
  }

  override hide(): void {
    if (this.cesiumEntity !== undefined) {
      this.hideBuilding();
      this.showFloors();
    }
  }

  override show(): void {
    if (this.cesiumEntity !== undefined) {
      this.showBuilding();
      this.showFloors();
    }
  }

  override getCesiumEntity(): any {
    if (this.cesiumEntity === undefined) {
      this.buildEntity();
    }
    this.cesiumEntity.arcLiveMapEntity = this;
    return this.cesiumEntity;
  }

  override onDelete(): void {
    
    // DataContext.removeMapEntity(childEntity);
  }

  showBuilding(): void {
    if (this.cesiumEntity) {
      this.cesiumEntity.show = true;
    }
    if (this.relatedEntities) {
      this.relatedEntities.forEach(entity => {
        if (typeof entity?.show === 'function') {
          entity.show();
        } else if (entity) {
          entity.show = true;
        }
      });
    }
  }

  hideBuilding(): void {
    if (this.cesiumEntity) {
      this.cesiumEntity.show = false;
    }
    if (this.relatedEntities) {
      this.relatedEntities.forEach(entity => {
        if (typeof entity?.hide === 'function') {
          entity.hide();
        } else if (entity) {
          entity.show = false;
        }
      });
    }
  }

  showFloorOnly(floorId: string): void {
    this.showInterior();
    this.floorPerimeters.forEach(floor => {
      if (floor.getId() !== floorId) {
        floor.hide();
      } else {
        floor.show(true);
      }
    });
  }
    showInterior() {
        throw new Error("Method not implemented.");
    }

  hideBuildingAndFloors(): void {
    if (!this.isExteriorVisible) {
      this.hide();
      this.showFloors();
    } else if (this.isExteriorVisible) {
      this.show();
      this.showFloors();
    }
  }

  getFloorPerimeters(): any[] {
    return this.floorPerimeters;
  }

  setCameras(): void {}

  getCameras(): void {}

  isAssociatedWithOrg(orgId: string): boolean {
    return !!this.associatedOrgs[orgId];
  }

  addAssociatedOrg(orgId: string): void {
    this.associatedOrgs[orgId] = true;
  }

  isIncidentABuildingIncident(incident: any): boolean {
    if (!incident?.affectedPerimeterIds?.length) return false;
    const campuses = this.orgutil?.data?.myCampus?.campuses || [];
    const campusIds = campuses.map((c: any) => String(c.campusId));
    const hasCampusMatch = incident.affectedPerimeterIds.some(
      (perimId: string) => campusIds.includes(perimId)
    );

    if (hasCampusMatch) {
      incident?.setBuilding(this);
      return true;
    }

    for (const perimId of incident.affectedPerimeterIds) {
      for (const floor of this.floorPerimeters) {
        if (floor?.containsPerimeterId(perimId)) {
          incident?.setBuilding(this);
          return true;
        }
      }
    }
    return false;
  }

  addIncident(incident: any): void {
    if (!this.incidents.some(i => i.getEventId() === incident.getEventId())) {
      this.incidents.push(incident);
    }
  }

  removeIncident(id: string): void {
    this.incidents = this.incidents.filter(i => i.getEventId() !== id);
  }

  getListOfIncidents(): any[] {
    return this.incidents;
  }

  getListOfCurrentIncidents(): any[] {
    return this.incidents.filter(i =>
      (i.getStatus() === 'pending' || i.getStatus() === 'active') && i.getIsAddedMap()
    );
  }

  setBottomCameraView(
    baseViewLat: number,
    baseViewLon: number,
    baseViewRange: number,
    baseViewHeading: number,
    baseViewPitch: number,
    baseViewHeight: number
  ): void {
    this.initViewPosLat = baseViewLat;
    this.initViewPosLon = baseViewLon;
    this.initViewRange = baseViewRange;
    this.initViewHeading = baseViewHeading;
    this.initViewPitch = baseViewPitch;
    this.initViewHeight = baseViewHeight;
  }

  addBuildingRelationEntity(entity: any): void {
    this.relatedEntities.push(entity);
  }

  getRelatedEntities(): any[] {
    return this.relatedEntities;
  }

  setSurroundings(surroundings: any): void {
    this.surroundings = surroundings;
  }

  getSurroundings(): any {
    return this.surroundings;
  }

  getCenterFloor(): any {
    if (!this.centerfloor) {
      const center = Math.ceil(this.floorPerimeters.length / 2);
      this.centerfloor = this.floorPerimeters[center] || this.floorPerimeters[0];
    }
    return this.centerfloor;
  }

  getLastFloorHeight(): number {
    if (this.floorPerimeters && this.floorPerimeters.length > 0) {
      return this.floorPerimeters[this.floorPerimeters.length - 1].extrudedHeight;
    }
    return 0;
  }

  override hasCustomCamera(): boolean {
    return true;
  }

  override getCustomCameraSettings(): { showCloseButton: boolean } {
    return { showCloseButton: !this.fixCamera };
  }

  override getCustomCamera(): string {
    return `<buildingcamera building-id=${this.getId()}></buildingcamera>`;
  }

  resetPerimeterSafetyStatus(): void {
    	_.forEach(this.floorPerimeters, (floor) => {
				_.forEach(floor.perimeters, (perimeter) => {
					perimeter.resetSafetyStatusByStats(perimeter);
				});
			});
    // this.floorPerimeters.forEach(floor => {
    //   floor.perimeters.forEach((perimeter: any) => {
    //     perimeter.resetSafetyStatusByStats();
    //   });
    // });
  }

 private threeJsMesh: any;

  setThreeJsMesh(mesh: any): void {
    this.threeJsMesh = mesh;
  }

  getThreeJsMesh(): any {
    return this.threeJsMesh;
  }
}